export const levels = {
  company: "company",
  site: "site",
  zone: "zone",
  childZone: "child",
  device: "device",
  externalDevice: "externalDevice",
};
